import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router"
import { RoleType } from "../../../App/enums"
import { not_found } from "../../../App/GlobaleVariables"
import { selectTranslations } from "../../../App/i18n/i18nSlice"
import { RootState } from "../../../App/store"
import { getOrganizationData } from "../../Organization/OrganizationDashboard/GetOrganizationServiceRequest"
import BackgroundWrapper from "../../Shared/Components/BackgroundWrapper"
import DonateButton from "../../Shared/Components/DonateButton"
import IndividualProfileCard from "../../Shared/Components/IndividualProfileCard"
import ModalGroup from "../../Shared/Components/ModalGroup"
import OrganizationProfileCard from "../../Shared/Components/OrganizationProfileCard"
import RoomDropdown from "../../Shared/Components/RoomDropdown"
import SponsorCard from "../../Shared/Components/SponsorCard"
import Header from "../../Shared/Header/Header"
import Footer from "../../Shared/Layout/Footer"
import MainLayout from "../../Shared/Layout/MainLayout"
import NewestMembersCard from "../../Shared/NewestMembers/NewestMemberCard"
import NewestOrganizationsCard from "../../Shared/NewestOrganizations/NewestOrganizations"
import UpcomingEventsDropdownItem from "../../UpcomingEvents/UpcomingEventsDropdownItem"

function UpcomingEventsScreen() {
    const donationLink = useSelector((state: RootState) => state.UserSettingsStatusSlice.userDonationLinkSlice.link)
    const translation = useSelector(selectTranslations)
    const role = useSelector((state: RootState) => state.rolesSlice.RolesSlice.roles)
    const events = useSelector((state: RootState) => state.upcomingEventsSlice.upcomingEvents)
    const [hasEvents, setHasEvents] = useState<boolean>()
    const { id } = useParams()
    const navigate = useNavigate()
        const notificationFilterNumber = 5
    const lastNotificationIndex = notificationFilterNumber - 1

    useEffect(() => {
        if (events.length === 0) {
            setHasEvents(false)
        } else {
            setHasEvents(true)
        }
        if (id) {
            getOrganizationData(id!)
                .then(response => {
                    if (!response.data.is_admin) {
                        navigate("/no-permission")
                    }
                })
                .catch()
        }
    }, [events.length])

    const onLastItem = (index: number) => {
        if (events.length < notificationFilterNumber) {
            return events.length - 1 === index
        } else {
            return index === lastNotificationIndex
        }
    }

     const onEventClick = (eventId: number, roomId: number) => {
            switch (role) {
                case RoleType.USER:
                    navigate(`/room/${roomId}?tab=events&event=${eventId}`)
                    break
                case RoleType.ORGANIZATION:
                    navigate(`/room/${id!}/${roomId}?tab=events&event=${eventId}`)
                    break
                default:
                    break
            }
        }

    return (
        <BackgroundWrapper>
            <Header />
            <MainLayout
                leftPanelFirstComponent={role === RoleType.USER ? <OrganizationProfileCard /> : <IndividualProfileCard />}
                leftPanelSecondComponent={<RoomDropdown type={RoleType.USER} />}
                leftPanelForthComponent={role === RoleType.USER && translation.newestOrganizations}
                leftPanelFifthComponent={role === RoleType.USER ? <NewestOrganizationsCard /> : null}
                RightPanelFirstComponent={donationLink === not_found ? <DonateButton /> : null}
                RightPanelSecondComponent={translation.newsMembersText}
                RightPanelThirdComponent={<NewestMembersCard />}
                RightPanelFifthComponent={<SponsorCard />}
                overflowModifier={true}
            >
                <div className="notifications-screen notifications-screen--upcoming-events">
                    <div className="notifications-screen__title-container">
                        <div className="notifications-screen__title">{translation.upcomingEvents}</div>
                    </div>
                    <div className="notifications-screen__card">
                        <div className="notifications-screen__content">
                            {hasEvents ? (
                                events?.map((event, index) => {
                                    return (
                                         <UpcomingEventsDropdownItem
                                            isLastItem={onLastItem(index)}
                                            name={event.title}
                                            key={event.id}
                                            id={event.id}
                                            format={event.formats}
                                            location={event.location_type}
                                            date={event.start_date}
                                            onClick={() => onEventClick(event.id, event.room.id)}
                                            roomId={event.room.id}
                                            image={event.image}
                                            roomName={event.room.name}
                                            isDropDown={false}
                                        />
                                    )
                                })
                            ) : (
                                <div className="notifications-screen__text">{translation.youHaveNoUpcomingEvents}</div>
                            )}
                        </div>
                    </div>
                </div>
            </MainLayout>
            <Footer />
            <ModalGroup />
        </BackgroundWrapper>
    )
}

export default UpcomingEventsScreen
